import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { Observable, Subscription } from 'rxjs';
import { LocationSelectService } from 'src/app/shared/location-select/location-select.service';
import { Locations } from '../location.model';

type PlaceResult = google.maps.places.PlaceResult;

@Component({
  selector: 'csi-address-autocomplete',
  templateUrl: './address-autocomplete.component.html',
  styleUrls: ['./address-autocomplete.component.css']
})
export class AddressAutocompleteComponent implements OnInit {
  @Input() public addressFormGroup: FormGroup;
  @Input() public showRequiredFields: boolean;
  @Output() regionsLoaded = new EventEmitter<Locations>();
  @ViewChild('googleAddressInput', { static: false })
  googleAddressInput?: ElementRef<HTMLInputElement>;

  public readonly countryWithProvincesOrStates$: Observable<
    string[]
  > = this.locationSelectService.getCountriesWithStateOrProvince();

  private translationSub: Subscription;

  constructor(
    private locationSelectService: LocationSelectService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit() {}

  ngAfterViewChecked(): void {
    this.translationSub = this.translocoService
      .selectTranslate('Enter a location')
      .subscribe(text => {
        if (this.googleAddressInput && this.googleAddressInput.nativeElement) {
          this.googleAddressInput.nativeElement.placeholder = text || 'Enter a location';
        }
      });
  }

  onCountryLocationChange() {
    this.addressFormGroup.controls.province.setValue('');
  }

  handleRegionsLoaded(regions: Locations) {
    this.regionsLoaded.emit(regions);
  }

  onAddressSelected(event: PlaceResult) {
    let country = '';
    let province = '';
    let postal_code = '';
    let city = '';

    event.address_components.forEach(address_component => {
      if (address_component.types.includes('country')) {
        country = address_component.short_name;
      } else if (address_component.types.includes('postal_code')) {
        postal_code = address_component.long_name;
      } else if (address_component.types.includes('administrative_area_level_1')) {
        province = address_component.short_name;
      } else if (
        address_component.types.includes('locality') &&
        address_component.types.includes('political')
      ) {
        city = address_component.long_name;
      }
    });

    const formControls = this.addressFormGroup.controls;
    formControls.address.setValue(event.name);
    formControls.country.setValue(country);
    formControls.city.setValue(city);

    formControls.province.setValue(province);

    formControls.postalCode.setValue(postal_code);
    this.addressFormGroup.markAsDirty();
    this.addressFormGroup.markAllAsTouched();
  }
}
